import {
  GridColumnConfig,
  GridColumnType,
  GridActionConfig,
  GridActionType,
  ToolbarButton,
  GridConfig,
} from '../../../../shared/components/kendo/grid';
import { FilterFieldConfig } from '../../../../shared/components/kendo/grid/components/grid-filter/grid-filter.component';
import { TEMPLATE_CONSTANTS } from './template-constants';
import { PERMISSIONS } from '../../../../shared/constants/permissions.constants';
import { PermissionChecker } from '../../../../core/components/base-grid/base-grid.component';

export const TEMPLATE_GRID_COLUMNS: GridColumnConfig[] = [
  {
    field: 'filename',
    title: 'Name',
    width: 180,
    filterable: true,
    sortable: true,
    type: GridColumnType.TEXT,
  },
  {
    field: 'syncstr',
    title: 'Date',
    width: 100,
    filterable: true,
    sortable: true,
    type: GridColumnType.TEXT,
  },
];

export const getTemplatesToolbarButtons = (
  handlers: {
    onUpload: () => void;
    onAddFolder: () => void;
  },
  can: PermissionChecker
): ToolbarButton[] => {
  const buttons: ToolbarButton[] = [];

  if (can(PERMISSIONS.TEMPLATE.UPLOAD)) {
    buttons.push({
      id: 'upload',
      text: 'Upload Template',
      icon: 'bi bi-upload',
      tooltip: 'Upload Template',
      className: 'btn-outline-secondary',
      handler: handlers.onUpload,
    });
  }

  if (can(PERMISSIONS.TEMPLATE.ADD_FOLDER)) {
    buttons.push({
      id: 'add',
      text: 'Add Folder',
      icon: 'bi bi-plus-circle',
      className: 'btn-primary',
      tooltip: 'Add Folder',
      handler: handlers.onAddFolder,
    });
  }

  return buttons;
};

export const getTemplateActions = (
  handlers: {
    onDownload: (item: any) => void;
    onEdit: (item: any) => void;
    onSignature: (item: any) => void;
  },
  can: PermissionChecker
): GridActionConfig[] => {
  const actions: GridActionConfig[] = [];

  if (can(PERMISSIONS.TEMPLATE.VIEW)) {
    actions.push({
      id: 'template-download',
      type: GridActionType.VIEW,
      text: 'Download',
      icon: 'bi bi-download',
      handler: handlers.onDownload,
      visible: () => true,
    });
  }

  if (can(PERMISSIONS.TEMPLATE.SIGNATURE_SETUP)) {
    actions.push({
      id: 'template-edit',
      type: GridActionType.EDIT,
      text: 'Edit',
      icon: 'bi bi-pencil-square',
      handler: handlers.onEdit,
      visible: () => true,
    });
  }

  if (can(PERMISSIONS.TEMPLATE.TEMPLATE_ASSIGN)) {
    actions.push({
      id: 'template-signature',
      type: GridActionType.VIEW,
      text: 'Signature',
      icon: 'bi bi-pencil',
      handler: handlers.onSignature,
      visible: (item) => item['isSignature'],
    });
  }

  return actions;
};

export const createTemplateGridConfig = (
  actions: GridActionConfig[],
  toolbarButtons: ToolbarButton[]
): GridConfig => {
  const columns: GridColumnConfig[] = [...TEMPLATE_GRID_COLUMNS];

  // Only add actions column if there are actions available
  if (actions.length > 0) {
    columns.push({
      field: 'actions',
      title: 'Actions',
      width: 120,
      filterable: false,
      sortable: false,
      type: GridColumnType.ACTIONS,
      actions: actions,
    });
  }

  return {
    columns,
    toolbarButtons: toolbarButtons,
    showSearch: true,
    pageable: {
      enabled: true,
      pageSize: TEMPLATE_CONSTANTS.DEFAULT_PAGE_SIZE,
      pageSizes: TEMPLATE_CONSTANTS.PAGE_SIZE_OPTIONS,
      showPageSizeSelector: true,
      showTotalCount: true,
      buttonCount: TEMPLATE_CONSTANTS.BUTTON_COUNT,
      previousNext: true,
      responsive: true,
    },
    sortable: {
      enabled: true,
      allowUnsort: true,
      mode: 'single' as any,
    },
    filterable: {
      enabled: true,
      mode: 'menu' as any,
    },
    groupable: {
      enabled: false,
    },
    selectable: {
      enabled: false,
    },
    resizable: true,
    reorderable: true,
  };
};

export const INITIAL_GRID_STATE = {
  skip: 0,
  take: TEMPLATE_CONSTANTS.DEFAULT_PAGE_SIZE,
  sort: [],
  filter: undefined,
  search: '',
};

export const TEMPLATE_PORTLET_CONFIG = TEMPLATE_CONSTANTS.PORTLET_CONFIG;

export const TEMPLATE_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    id: 'search',
    controlType: 'input',
    formControlName: 'search',
    config: {
      label: '',
      placeholder: 'Search template...',
      type: 'text',
      icon: 'bi bi-search',
    },
    width: '250px',
    className: 'filter-field search-control',
    applyTo: ['filename'],
    operator: 'contains',
    logic: 'or',
    debounceTime: 500,
    gridPosition: { colSpan: 3 },
  },
];
